import { render, staticRenderFns } from "./ScheduleMenu.vue?vue&type=template&id=d5d2c220&scoped=true&"
import script from "./ScheduleMenu.vue?vue&type=script&lang=js&"
export * from "./ScheduleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d2c220",
  null
  
)

export default component.exports